export default "__VITE_ASSET__cPZ$xxwe__"